export default "__VITE_ASSET__D7O8b$PT__"